import { Controller } from "stimulus";
import FileInput from "@uppy/file-input";
import Informer from "@uppy/informer";
import ProgressBar from "@uppy/progress-bar";
import ThumbnailGenerator from "@uppy/thumbnail-generator";
import { fileUpload, uploadedFileData } from "../src/admin/file_uploads.js";
export default class extends Controller {
  static targets = ["input", "imagePreview", "resultField"];
  fileInput;
  uppy;

  connect() {
    this.teardown = this.teardown.bind(this);
    // Turbolinks snapshots the page before disconnect runs, so restore the input first
    document.addEventListener("turbolinks:before-cache", this.teardown);
    this.setupFileUpload();
  }

  disconnect() {
    document.removeEventListener("turbolinks:before-cache", this.teardown);
    this.teardown();
  }

  teardown() {
    if (!this.uppy) return;

    this.uppy.close();
    this.uppy = null;
    this.element.insertBefore(this.fileInput, this.resultFieldTarget);
  }

  setupFileUpload() {
    this.fileInput = this.inputTarget;
    this.element.removeChild(this.inputTarget);

    this.uppy = fileUpload(this.fileInput, this.data.get("server"));
    // Capture clears the last upload before FileInput adds the pick and checks the one-file limit
    this.element.addEventListener("change", () => this.uppy?.cancelAll(), {
      capture: true,
    });

    this.uppy
      .use(FileInput, {
        target: this.element,
        locale: { strings: { chooseFiles: "Choose file" } },
        inputName: `${this.data.get("attribute")}_files[]`,
      })
      .use(Informer, {
        target: this.element,
      })
      .use(ProgressBar, {
        target: this.imagePreviewTarget.parentNode,
        hideAfterFinish: false,
      })
      .use(ThumbnailGenerator, {
        thumbnailWidth: 600,
      });

    this.uppy.on("upload-success", (file, response) => {
      this.onUploadSuccess(file, response);
    });
    this.uppy.on("thumbnail:generated", (_file, preview) => {
      this.imagePreviewTarget.src = preview;
    });
  }

  onUploadSuccess(file, response) {
    const fileData = uploadedFileData(file, response, this.data.get("server"));

    // set hidden field value to the uploaded file data so that it's submitted
    // with the form as the attachment
    this.resultFieldTarget.value = fileData;
  }
}
